<template>
  <field-group label="Danh sách lớp bản đồ">
    <draggable-group-list
      class="overflow-auto pa-4"
      :items.sync="layers"
      disabled-select
    >
      <template #item="{item,index}">
        <LayerItem :item="item" @click:delete="onDeleteLayer(item, index)" />
      </template>
    </draggable-group-list>
    <div class="px-4 pb-4 mt-n4">
      <v-sheet class="elevation-1">
        <v-card
          class="flex-grow-1 pa-2 d-flex align-center justify-center"
          flat
          @click="onShowAddLayer"
          min-height="65"
          tile
        >
          <v-icon size="50">mdi-plus</v-icon>
        </v-card>
      </v-sheet>
    </div>
    <LayerSelectDialog ref="layerselect" @submit="onAddSelectLayer" />
  </field-group>
</template>

<script>
import LayerSelectDialog from '@views/layers/layer-select-dialog.vue'
import { DraggableGroupList } from '@components/draggable'
import LayerItem from './layer-group-dialog-layer-item.vue'
export default {
  components: { DraggableGroupList, LayerItem, LayerSelectDialog },
  props: {
    value: { type: Array, default: () => [] },
  },
  data: () => ({}),
  computed: {
    layers: {
      get() {
        return this.value.slice().reverse()
      },
      set(value) {
        this.$emit('input', value.slice().reverse())
      },
    },
  },
  methods: {
    onDeleteLayer(item, index) {
      let value = this.layers.slice()
      value.splice(index, 1)
      this.layers = value
    },
    onAddSelectLayer(items) {
      if (!this.layers) {
        this.layers = []
      }
      this.layers = this.layers.concat(items)
    },
    onShowAddLayer() {
      this.$refs.layerselect.open()
    },
  },
}
</script>

<style scoped></style>
